<!-- @format -->

<template>
  <div>
    <div class="ui segment">
      <div class="ui grid">
        <div class="ui row">
          <div class="ui twelve wide column">
            <h1 class="ui sub header">
              <span style="font-size: large"> Projected Income </span>
            </h1>
            <span class="ui">hover over graph for detail</span>
            <br />
            <br />
          </div>
          <div class="four wide column" style="font-size: small">
            <div
              class="ui mini toggle checkbox"
              style="float: right !important; font-size: 10px;"
            >
              <input
                type="checkbox"
                @change="adjustInflation"
                v-model="adjustForInflation"
              />
              <label
                >{{
                  !adjustForInflation ? "Show" : "Hide"
                }}
                inflation-adjusted</label
              >
            </div>
          </div>
        </div>
        <div class="ui row" v-if="selectedAge.year > 0">
          <div class="two wide column " style="border-right: 1px solid grey">
            <h1 class="ui sub header">
              <span style="font-size: 1.3em">
                <AnimatedNumber
                  :startNumber="selectedAge.year"
                  :number="selectedAge.year"
                  :fmt="'0,0'"
                />
              </span>
            </h1>
            <span class="ui" style="font-size: 0.85em">
              age
            </span>
          </div>
          <div class="three wide column " style="border-right: 1px solid grey">
            <h1 class="ui sub header">
              <span style="font-size: 1.3em" v-if="selectedAge">
                R
                <AnimatedNumber
                  :startNumber="
                    selectedAge[
                      highlightLessLikelyRange
                        ? 'income' +
                          (highlightPessimisticRange
                            ? 'Pessimistic'
                            : 'Optimistic') +
                          'Value2'
                        : 'income' +
                          (highlightPessimisticRange
                            ? 'Pessimistic'
                            : 'Optimistic') +
                          'Value3'
                    ]
                  "
                  :number="
                    selectedAge[
                      highlightLessLikelyRange
                        ? 'income' +
                          (highlightPessimisticRange
                            ? 'Pessimistic'
                            : 'Optimistic') +
                          'Value2'
                        : 'income' +
                          (highlightPessimisticRange
                            ? 'Pessimistic'
                            : 'Optimistic') +
                          'Value3'
                    ]
                  "
                  :fmt="'0,0'"
                />
              </span>
            </h1>
            <span class="ui" style="font-size: 0.85em">
              <div
                v-if="highlightLessLikelyRange"
                class="box lesslikely"
                :style="
                  'opacity:' +
                    appearanceSettings.appearanceSchema.graphColorOpacity2 +
                    ';background-color: ' +
                    appearanceSettings.appearanceSchema.graphColorRange2
                "
              ></div>
              <div
                v-else
                class="box"
                :style="
                  'opacity:' +
                    appearanceSettings.appearanceSchema.graphColorOpacity +
                    ';background-color: ' +
                    appearanceSettings.appearanceSchema.graphColor
                "
              ></div>
              income per annum
              <span v-if="adjustForInflation">& adjusted for inflation</span>
            </span>
          </div>
          <div class="five wide column " style="border-right: 1px solid grey">
            <h1 class="ui sub header">
              <span style="font-size: 1.3em" v-if="selectedAge">
                <AnimatedNumber
                  :startNumber="
                    selectedAge[
                      highlightLessLikelyRange
                        ? 'incomePercent' +
                          (highlightPessimisticRange
                            ? 'Pessimistic'
                            : 'Optimistic') +
                          'Value2'
                        : 'incomePercent' +
                          (highlightPessimisticRange
                            ? 'Pessimistic'
                            : 'Optimistic') +
                          'Value3'
                    ]
                  "
                  :number="
                    selectedAge[
                      highlightLessLikelyRange
                        ? 'incomePercent' +
                          (highlightPessimisticRange
                            ? 'Pessimistic'
                            : 'Optimistic') +
                          'Value2'
                        : 'incomePercent' +
                          (highlightPessimisticRange
                            ? 'Pessimistic'
                            : 'Optimistic') +
                          'Value3'
                    ]
                  "
                  :fmt="'0,0.0%'"
                />
              </span>
            </h1>
            <span class="ui" style="font-size: 0.85em">
              <div
                v-if="highlightLessLikelyRange"
                class="box lesslikely"
                :style="
                  'opacity:' +
                    appearanceSettings.appearanceSchema.graphColorOpacity2 +
                    ';background-color: ' +
                    appearanceSettings.appearanceSchema.graphColorRange2
                "
              ></div>
              <div
                v-else
                class="box"
                :style="
                  'opacity:' +
                    appearanceSettings.appearanceSchema.graphColorOpacity +
                    ';background-color: ' +
                    appearanceSettings.appearanceSchema.graphColor
                "
              ></div>
              income %
            </span>
          </div>
          <div class="three wide column" style="border-right: 1px solid grey">
            <div>
              <div
                :class="
                  'box big selectable ' +
                    (highlightLessLikelyRange ? 'selected' : 'unselected')
                "
                :style="
                  'opacity: ' +
                    appearanceSettings.appearanceSchema.graphColorOpacity +
                    ';background-color: ' +
                    appearanceSettings.appearanceSchema.graphColor
                "
              ></div>
              <a
                href="#"
                @click.prevent="highlightRange('More Likely')"
                :class="!highlightLessLikelyRange ? 'selected' : 'unselected'"
              >
                More Likely </a
              ><strong v-if="!highlightLessLikelyRange">
                <i class="ui icon angle double left"></i>
              </strong>
              <br />
              <div
                class="box big lesslikely selectable"
                :style="
                  'opacity: ' +
                    appearanceSettings.appearanceSchema.graphColorOpacity2 +
                    ';background-color: ' +
                    appearanceSettings.appearanceSchema.graphColorRange2
                "
              ></div>
              <a
                href="#"
                @click.prevent="highlightRange('Less Likely')"
                :class="highlightLessLikelyRange ? 'selected' : ''"
              >
                Less Likely </a
              ><strong v-if="highlightLessLikelyRange">
                <i class="ui icon angle double left"></i>
              </strong>
            </div>
          </div>
          <div class="three wide column">
            <div>
              🔅
              <a
                href="#"
                @click.prevent="highlightConditions('Pessimistic')"
                :class="highlightPessimisticRange ? 'selected' : 'unselected'"
              >
                Pessimistic Returns</a
              ><strong v-if="highlightPessimisticRange">
                <i class="ui icon angle double left"></i>
              </strong>
              <br />

              🌞
              <a
                href="#"
                @click.prevent="highlightConditions('Optimistic')"
                :class="!highlightPessimisticRange ? 'selected' : ''"
              >
                Optimistic Returns</a
              ><strong v-if="!highlightPessimisticRange">
                <i class="ui icon angle double left"></i>
              </strong>
            </div>
          </div>
        </div>
      </div>

      <dx-chart
        style="height: 270px"
        id="chart2"
        :data-source="chartProjections"
        :customize-point="customizeIncomePoint"
      >
        <dx-common-series-settings
          :type="type"
          value-field="targetIncome"
          argument-field="year"
          :grid="{ visible: false }"
        />
        <dx-common-axis-settings :color="colors.graph.axisColor">
          <dx-label>
            <dx-font :color="colors.graph.fontColor" />
          </dx-label>
        </dx-common-axis-settings>

        <dx-legend
          :visible="false"
          vertical-alignment="bottom"
          horizontal-alignment="center"
          item-text-position="bottom"
        >
          <dx-font :color="colors.graph.fontColor" />
        </dx-legend>

        <dx-series
          color="grey"
          argument-field="year"
          :value-field="
            highlightLessLikelyRange
              ? 'income' +
                (highlightPessimisticRange ? 'Pessimistic' : 'Optimistic') +
                'Value2'
              : 'income' +
                (highlightPessimisticRange ? 'Pessimistic' : 'Optimistic') +
                'Value3'
          "
          name="Projected Income"
          type="bar"
          :opacity="0.5"
        />

        <dx-series
          color="black"
          argument-field="year"
          value-field="targetIncome"
          name="Targeted Income"
          type="line"
          dashStyle="longDash"
          :point="pointIncomeOptions"
        ></dx-series>
        <dx-margin :bottom="20" />
        <dx-argument-axis
          :value-margins-enabled="false"
          discrete-axis-division-mode="crossLabels"
        >
          <dx-label>
            <dx-font :color="colors.graph.fontColor" />
          </dx-label>
          <dx-tick :visible="false"></dx-tick>
          <dx-grid :visible="false" />
        </dx-argument-axis>
        <dx-value-axis :visible="false" position="right">
          <dx-grid opacity="0.3" :color="colors.graph.axisColor"></dx-grid>
          <dx-label :visible="true"></dx-label>
        </dx-value-axis>

        <dx-tooltip
          :enabled="true"
          :customize-tooltip="customizeTooltipIncome"
        />
      </dx-chart>
      <Section>
        <div class="ui attached message" v-if="!highlightLessLikelyRange">
          <span
            class="box bhead"
            :style="
              !highlightLessLikelyRange
                ? 'opacity:' +
                  appearanceSettings.appearanceSchema.graphColorOpacity +
                  ';background-color: ' +
                  appearanceSettings.appearanceSchema.graphColor
                : 'opacity:' +
                  appearanceSettings.appearanceSchema.graphColorOpacity2 +
                  ';background-color: ' +
                  appearanceSettings.appearanceSchema.graphColorRange2
            "
          ></span
          >Key Highlights for the
          <strong
            >{{
              highlightPessimisticRange ? "pessimistic " : "optimistic "
            }} </strong
          ><strong>more likely</strong> range of outcomes
        </div>
        <div class="ui attached message" v-if="highlightLessLikelyRange">
          <span
            class="box bhead lesslikely"
            :style="
              !highlightLessLikelyRange
                ? 'opacity:' +
                  appearanceSettings.appearanceSchema.graphColorOpacity +
                  ';background-color: ' +
                  appearanceSettings.appearanceSchema.graphColor
                : 'opacity:' +
                  appearanceSettings.appearanceSchema.graphColorOpacity2 +
                  ';background-color: ' +
                  appearanceSettings.appearanceSchema.graphColorRange2
            "
          ></span>
          Key Highlights for the
          <strong
            >{{ highlightPessimisticRange ? "pessimistic " : "optimistic " }}
          </strong>
          <strong>less likely</strong>
          range of outcomes
        </div>
        <div class="ui attached segment">
          <div class="ui sixteen column grid">
            <div class="ui row">
              <div class="sixteen wide column">
                <div class="ui">
                  <div class="ui horizontal divider">
                    <span v-if="!highlightLessLikelyRange">
                      <span
                        class="box dividr"
                        :style="
                          !highlightLessLikelyRange
                            ? 'opacity:' +
                              appearanceSettings.appearanceSchema
                                .graphColorOpacity +
                              ';background-color: ' +
                              appearanceSettings.appearanceSchema.graphColor
                            : 'opacity:' +
                              appearanceSettings.appearanceSchema
                                .graphColorOpacity2 +
                              ';background-color: ' +
                              appearanceSettings.appearanceSchema
                                .graphColorRange2
                        "
                      ></span>
                      Highlights<span v-if="highlightPessimisticRange">🔅</span
                      ><span v-else>🌞</span></span
                    >
                    <span v-else>
                      <span
                        class="box dividr lesslikely"
                        :style="
                          'opacity:' +
                            appearanceSettings.appearanceSchema
                              .graphColorOpacity2 +
                            ';background-color: ' +
                            appearanceSettings.appearanceSchema.graphColorRange2
                        "
                      ></span>
                      Highlights<span v-if="highlightPessimisticRange">🔅</span
                      ><span v-else>🌞</span></span
                    >
                  </div>
                  <table class="ui very compact table">
                    <thead>
                      <tr>
                        <th>Year</th>
                        <th style="text-align: center">Target for year</th>
                        <th style="text-align: center">Income for year</th>
                        <th style="text-align: center">
                          Income % of Balance
                        </th>
                      </tr>
                    </thead>
                    <tr>
                      <td>
                        Age

                        {{ chartProjections[1].year }}
                      </td>
                      <td style="text-align: center">
                        R

                        {{ formatNr(chartProjections[1].targetIncome) }}
                      </td>
                      <td style="text-align: center">
                        R
                        {{
                          formatNr(
                            chartProjections[1][
                              "income" +
                                (highlightPessimisticRange
                                  ? "Pessimistic"
                                  : "Optimistic") +
                                (highlightLessLikelyRange ? "Value2" : "Value3")
                            ]
                          )
                        }}
                      </td>

                      <td style="text-align: center">
                        {{
                          formatNr(
                            chartProjections[1][
                              "incomePercent" +
                                (highlightPessimisticRange
                                  ? "Pessimistic"
                                  : "Optimistic") +
                                (highlightLessLikelyRange ? "Value2" : "Value3")
                            ],
                            "0,0.0%"
                          )
                        }}
                      </td>
                    </tr>
                    <tr v-if="selectedAge">
                      <td>
                        Age
                        {{ selectedAge.year }}
                      </td>
                      <td style="text-align: center">
                        R
                        {{ formatNr(selectedAge.targetIncome) }}
                      </td>
                      <td style="text-align: center">
                        R
                        {{
                          formatNr(
                            selectedAge[
                              "income" +
                                (highlightPessimisticRange
                                  ? "Pessimistic"
                                  : "Optimistic") +
                                (highlightLessLikelyRange ? "Value2" : "Value3")
                            ]
                          )
                        }}
                      </td>

                      <td style="text-align: center">
                        {{
                          formatNr(
                            selectedAge[
                              "incomePercent" +
                                (highlightPessimisticRange
                                  ? "Pessimistic"
                                  : "Optimistic") +
                                (highlightLessLikelyRange ? "Value2" : "Value3")
                            ],
                            "0,0.0%"
                          )
                        }}
                      </td>
                    </tr>

                    <tr>
                      <td>
                        Age
                        {{ chartProjections[chartProjections.length - 1].year }}
                      </td>
                      <td style="text-align: center">
                        R
                        {{
                          formatNr(
                            chartProjections[chartProjections.length - 1]
                              .targetIncome
                          )
                        }}
                      </td>
                      <td style="text-align: center">
                        R
                        {{
                          formatNr(
                            chartProjections[chartProjections.length - 1][
                              "income" +
                                (highlightPessimisticRange
                                  ? "Pessimistic"
                                  : "Optimistic") +
                                (highlightLessLikelyRange ? "Value2" : "Value3")
                            ]
                          )
                        }}
                      </td>

                      <td style="text-align: center">
                        {{
                          formatNr(
                            chartProjections[chartProjections.length - 1][
                              "incomePercent" +
                                (highlightPessimisticRange
                                  ? "Pessimistic"
                                  : "Optimistic") +
                                (highlightLessLikelyRange ? "Value2" : "Value3")
                            ],
                            "0,0.0%"
                          )
                        }}
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div></Section
      >
    </div>
  </div>
</template>
<script>
import * as _ from "lodash";
import numeral from "numeral";

import AnimatedNumber from "@/components/AnimatedNumber.vue";
import {
  DxChart,
  DxSeries,
  DxArgumentAxis,
  DxValueAxis,
  DxCommonAxisSettings,
  DxCommonSeriesSettings,
  DxGrid,
  DxMargin,
  DxLegend,
  DxTick,
  DxTooltip,
  DxLabel,
  DxFont,
} from "devextreme-vue/chart";
export default {
  name: "ChartProjectedBalances",
  props: {
    appearanceSettings: Object,
    incomeProjectionRequest: Object,
    projectionRequest: Object,
    colors: Object,
    chartProjections: Array,
    currentAge: Number,
    selected: Object,
    adjustForInflation: Boolean,
    // selectedPoint: Object,
    show: Boolean,
  },
  components: {
    AnimatedNumber,
    DxChart,
    DxSeries,
    DxArgumentAxis,
    DxValueAxis,
    DxCommonAxisSettings,
    DxCommonSeriesSettings,
    DxGrid,
    DxMargin,
    DxLabel,
    DxLegend,
    DxTick,
    DxTooltip,
    DxFont,
  },
  data() {
    return {
      highlightLessLikelyRange: false,
      highlightPessimisticRange: true,
      selectedPoint: {
        index: 0,
        age: 0,
        income: 0,
      },
      pointIncomeOptions: { visible: false },
    };
  },
  computed: {
    selectedAge: function() {
      if (
        this.chartProjections[this.selectedPoint.index + 1] &&
        this.selectedPoint.age != 0
      )
        return this.chartProjections[this.selectedPoint.index + 1];
      else if (this.chartProjections[this.chartProjections.length - 1])
        return this.chartProjections[this.chartProjections.length - 1];
      else if (this.chartProjections[1]) return this.chartProjections[1];
      return null;
    },
  },
  methods: {
    highlightRange(val) {
      if (val == "More Likely") {
        this.highlightLessLikelyRange = false;
      } else {
        this.highlightLessLikelyRange = true;
      }
      //  this.adjustInflation();
    },
    highlightConditions(val) {
      if (val == "Pessimistic") {
        this.highlightPessimisticRange = true;
      } else {
        this.highlightPessimisticRange = false;
      }
      //   this.adjustInflation();
    },
    map: function(arr, obj) {
      return _.map(arr, _.partialRight(_.pick, obj));
    },
    flatten: function(arr) {
      return _.flattenDeep(arr);
    },
    filter: function(arr, filtr) {
      return _.filter(arr, filtr);
    },
    incomeGreaterThan: function(arr, filtr) {
      // _.filter(users, ({age}) => age > 30)
      return _.filter(arr, ({ income }) => income > filtr);
    },
    incomePercentGreaterThan: function(arr, filtr) {
      // _.filter(users, ({age}) => age > 30)
      return _.filter(arr, ({ incomePercent }) => incomePercent > filtr);
    },
    take: function(arr, size) {
      return _.take(arr, size);
    },
    formatNr(val, fmt) {
      if (fmt) return numeral(val).format(fmt);
      else return numeral(val).format("0,0.0a");
    },
    adjustInflation() {
      this.$emit("handleInflationChanged", {
        adjustForInflation: this.adjustForInflation,
      });
    },

    customizeTooltipIncome(pointInfo) {
      let indexP = pointInfo.argument - this.currentAge;

      this.selectedPoint.index = indexP - 1;
      this.selectedPoint.age = this.chartProjections[indexP - 1].year;
      indexP = indexP + 1;
      if (this.chartProjections[indexP - 1]) {
        let pct = numeral(
          this.chartProjections[indexP - 1][
            "incomePercent" +
              (this.highlightPessimisticRange ? "Pessimistic" : "Optimistic") +
              (this.highlightLessLikelyRange ? "Value2" : "Value3")
          ]
        ).format("0,00.0%");
        let incomeAmount = numeral(
          this.chartProjections[indexP - 1][
            "income" +
              (this.highlightPessimisticRange ? "Pessimistic" : "Optimistic") +
              (this.highlightLessLikelyRange ? "Value2" : "Value3")
          ]
        ).format("0,00.0a");
        let targetAmount = numeral(
          this.chartProjections[indexP - 1].targetIncome
        ).format("0,00.0a");
        let warningMessage = `
          <div class='tooltip-header-warning2'> ${
            this.chartProjections[indexP - 1][
              "incomePercent" +
                (this.highlightPessimisticRange
                  ? "Pessimistic"
                  : "Optimistic") +
                (this.highlightLessLikelyRange ? "Value2" : "Value3")
            ] >= 0.1
              ? "Warning"
              : ""
          }</div>
          <div class='tooltip-body'><div class='warning-text'> ${
            this.chartProjections[indexP - 1][
              "incomePercent" +
                (this.highlightPessimisticRange
                  ? "Pessimistic"
                  : "Optimistic") +
                (this.highlightLessLikelyRange ? "Value2" : "Value3")
            ] >= 0.1
              ? "Drawing high income!"
              : ""
          }</div></div>
          </div>`;

        let fallShortMessage = `
          <div class='tooltip-header-warning1'> ${
            this.chartProjections[indexP - 1][
              "incomePercent" +
                (this.highlightPessimisticRange
                  ? "Pessimistic"
                  : "Optimistic") +
                (this.highlightLessLikelyRange ? "Value2" : "Value3")
            ] >= 1
              ? "Off-Track!"
              : ""
          }</div>
          <div class='tooltip-body'><div class='warning-text1'> ${
            this.chartProjections[indexP - 1][
              "incomePercent" +
                (this.highlightPessimisticRange
                  ? "Pessimistic"
                  : "Optimistic") +
                (this.highlightLessLikelyRange ? "Value2" : "Value3")
            ] >= 1
              ? "You are falling short of targeted income"
              : ""
          }</div></div>
          </div>`;
        let finalMsg = ``;
        if (this.chartProjections[indexP - 1].income < 0.1) {
          finalMsg = fallShortMessage;
        } else if (
          this.chartProjections[indexP - 1][
            "incomePercent" +
              (this.highlightPessimisticRange ? "Pessimistic" : "Optimistic") +
              (this.highlightLessLikelyRange ? "Value2" : "Value3")
          ] > 0.1
        ) {
          finalMsg = warningMessage;
        }

        return {
          html: `<div><div class='tooltip-header'><strong>Age: ${
            pointInfo.argument
          }</strong></div>

        <div class='tooltip-body'>
        <div class='series-name'>Target (R): </div><div class='value-text'>R${targetAmount}</div>
        <div class='series-name'>Income (R): </div><div class='value-text'>R${incomeAmount}</div>
        <div class='series-name'>Income (%)</div><div class='value-text'>${pct}</div>
        </div>
        `,
        };
      }
    },
    customizeIncomePoint(arg) {
      let indexP = arg.argument - this.currentAge;
      indexP = indexP + 1;

      if (this.chartProjections[indexP - 1]) {
        if (
          this.chartProjections[indexP - 1][
            "incomePercent" +
              (this.highlightPessimisticRange ? "Pessimistic" : "Optimistic") +
              (this.highlightLessLikelyRange ? "Value2" : "Value3")
          ] == 0
        ) {
          return { color: "#FF3333", hoverStyle: { color: "#FF3333" } };
        } else if (
          this.chartProjections[indexP - 1][
            "incomePercent" +
              (this.highlightPessimisticRange ? "Pessimistic" : "Optimistic") +
              (this.highlightLessLikelyRange ? "Value2" : "Value3")
          ] > 0.15
        ) {
          return { color: "#FF3333", hoverStyle: { color: "#FF3333" } };
        } else if (
          this.chartProjections[indexP - 1][
            "incomePercent" +
              (this.highlightPessimisticRange ? "Pessimistic" : "Optimistic") +
              (this.highlightLessLikelyRange ? "Value2" : "Value3")
          ] > 0.14
        ) {
          return { color: "#F53D3D", hoverStyle: { color: "#F53D3D" } };
        } else if (
          this.chartProjections[indexP - 1][
            "incomePercent" +
              (this.highlightPessimisticRange ? "Pessimistic" : "Optimistic") +
              (this.highlightLessLikelyRange ? "Value2" : "Value3")
          ] > 0.13
        ) {
          return { color: "#EB4747", hoverStyle: { color: "#EB4747" } };
        } else if (
          this.chartProjections[indexP - 1][
            "incomePercent" +
              (this.highlightPessimisticRange ? "Pessimistic" : "Optimistic") +
              (this.highlightLessLikelyRange ? "Value2" : "Value3")
          ] > 0.12
        ) {
          return { color: "#E05252", hoverStyle: { color: "#E05252" } };
        } else if (
          this.chartProjections[indexP - 1][
            "incomePercent" +
              (this.highlightPessimisticRange ? "Pessimistic" : "Optimistic") +
              (this.highlightLessLikelyRange ? "Value2" : "Value3")
          ] > 0.11
        ) {
          return { color: "#D65C5C", hoverStyle: { color: "#D65C5C" } };
        } else if (
          this.chartProjections[indexP - 1][
            "incomePercent" +
              (this.highlightPessimisticRange ? "Pessimistic" : "Optimistic") +
              (this.highlightLessLikelyRange ? "Value2" : "Value3")
          ] > 0.1
        ) {
          return { color: "#CC6666", hoverStyle: { color: "#CC6666" } };
        } else if (
          this.chartProjections[indexP - 1][
            "incomePercent" +
              (this.highlightPessimisticRange ? "Pessimistic" : "Optimistic") +
              (this.highlightLessLikelyRange ? "Value2" : "Value3")
          ] > 0.09
        ) {
          return { color: "#AD8585", hoverStyle: { color: "#AD8585" } };
        } else if (
          this.chartProjections[indexP - 1][
            "incomePercent" +
              (this.highlightPessimisticRange ? "Pessimistic" : "Optimistic") +
              (this.highlightLessLikelyRange ? "Value2" : "Value3")
          ] < 0.02
        ) {
          return { color: "#95BF40", hoverStyle: { color: "#95BF40" } };
        } else if (
          this.chartProjections[indexP - 1][
            "incomePercent" +
              (this.highlightPessimisticRange ? "Pessimistic" : "Optimistic") +
              (this.highlightLessLikelyRange ? "Value2" : "Value3")
          ] < 0.03
        ) {
          return { color: "#90B24D", hoverStyle: { color: "#90B24D" } };
        } else if (
          this.chartProjections[indexP - 1][
            "incomePercent" +
              (this.highlightPessimisticRange ? "Pessimistic" : "Optimistic") +
              (this.highlightLessLikelyRange ? "Value2" : "Value3")
          ] < 0.04
        ) {
          return { color: "#8CA659", hoverStyle: { color: "#8CA659" } };
        } else if (
          this.chartProjections[indexP - 1][
            "incomePercent" +
              (this.highlightPessimisticRange ? "Pessimistic" : "Optimistic") +
              (this.highlightLessLikelyRange ? "Value2" : "Value3")
          ] < 0.05
        ) {
          return { color: "#889966", hoverStyle: { color: "#889966" } };
        } else if (
          this.chartProjections[indexP - 1][
            "incomePercent" +
              (this.highlightPessimisticRange ? "Pessimistic" : "Optimistic") +
              (this.highlightLessLikelyRange ? "Value2" : "Value3")
          ] < 0.06
        ) {
          return { color: "#848C73", hoverStyle: { color: "#848C73" } };
        }
      }
    },
  },
  async mounted() {},
};
</script>

<style type="text/css">
.box {
  float: left;
  height: 10px;
  width: 10px;
  margin-top: 4px;
  margin-right: 2px;

  border: 0px solid black;
  clear: both;
}

.lesslikely {
}

.big {
  margin-top: 3px;
  height: 14px;
  width: 14px;
  border: 1px solid black;
}

.dividr {
  margin-top: 0px;
  height: 14px;
  width: 14px;
  border: 1px solid black;
}

.bhead {
  margin-top: 5px;
  margin-right: 5px;
  height: 20px;
  width: 20px;
  border: 2px solid black;
}

.selectable {
  cursor: pointer;
}

.unselected {
  font-weight: 100;
}

.selected {
  color: black;
  font-weight: bold;
  cursor: auto;
}

.tooltip-header {
  margin-bottom: 5px;
  font-size: 16px;
  font-weight: 500;
  padding-bottom: 5px;
  border-bottom: 1px solid #c5c5c5;
}
.tooltip-header-warning1 {
  margin-bottom: 5px;
  font-size: 16px;
  font-weight: 500;
  padding-top: 5px;
  border-top: 1px solid #c5c5c5;
  color: #ff3333;
}

.tooltip-body .warning-text1 {
  display: inline-block;
  line-height: 1.5;
  color: #ff3333;
}
.tooltip-header-warning2 {
  margin-bottom: 5px;
  font-size: 16px;
  font-weight: 500;
  padding-top: 5px;
  border-top: 1px solid #c5c5c5;
  color: #cc6666;
}

.tooltip-header-warning {
  margin-bottom: 5px;
  font-size: 16px;
  font-weight: 500;
  padding-top: 5px;
  border-top: 1px solid #c5c5c5;
  color: red;
}

.tooltip-body {
  width: 170px;
}

.tooltip-body .series-name-average {
  font-weight: bold;
  font-size: 16px;
  opacity: 0.6;
  display: inline-block;
  line-height: 1.9;
  padding-right: 10px;
  width: 126px;
}

.tooltip-body .series-name {
  font-weight: normal;
  opacity: 0.6;
  display: inline-block;
  line-height: 1.5;
  padding-right: 10px;
  width: 126px;
}

.tooltip-body .warning-text {
  display: inline-block;
  line-height: 1.5;
  color: #cc6666;
}

.tooltip-body .value-text {
  display: inline-block;
  line-height: 1.5;
  width: 30px;
}

.tooltip-body .value-text-average {
  font-weight: bold;
  font-size: 16px;
  display: inline-block;
  line-height: 1.9;
  width: 30px;
}
</style>
